var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"train-none-data"},[_c('div',{staticClass:"empty-block"},[_c('img',{staticClass:"empty-img",attrs:{"src":require("@/assets/images/zone/img18.png"),"alt":""}}),_vm._v(" "),_c('div',{staticClass:"empty-txt"},[_vm._v(_vm._s(_vm.emptyTxt))])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-f941cd1e","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/training/trainNoneData.vue
// module id = null
// module chunks = 